import _classCallCheck from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/*!
 * RichTextResolver v3.3.1
 * Universal JavaScript SDK for Storyblok's API
 * (c) 2020-2021 Stobylok Team
 */
var t = function t(_t, r) {
  if (!_t) return null;
  var e = {};

  for (var n in _t) {
    var a = _t[n];
    r.indexOf(n) > -1 && null !== a && (e[n] = a);
  }

  return e;
};

var r = {
  nodes: {
    horizontal_rule: function horizontal_rule(t) {
      return {
        singleTag: "hr"
      };
    },
    blockquote: function blockquote(t) {
      return {
        tag: "blockquote"
      };
    },
    bullet_list: function bullet_list(t) {
      return {
        tag: "ul"
      };
    },
    code_block: function code_block(t) {
      return {
        tag: ["pre", {
          tag: "code",
          attrs: t.attrs
        }]
      };
    },
    hard_break: function hard_break(t) {
      return {
        singleTag: "br"
      };
    },
    heading: function heading(t) {
      return {
        tag: "h" + t.attrs.level
      };
    },
    image: function image(r) {
      return {
        singleTag: [{
          tag: "img",
          attrs: t(r.attrs, ["src", "alt", "title"])
        }]
      };
    },
    list_item: function list_item(t) {
      return {
        tag: "li"
      };
    },
    ordered_list: function ordered_list(t) {
      return {
        tag: "ol"
      };
    },
    paragraph: function paragraph(t) {
      return {
        tag: "p"
      };
    }
  },
  marks: {
    bold: function bold() {
      return {
        tag: "b"
      };
    },
    strike: function strike() {
      return {
        tag: "strike"
      };
    },
    underline: function underline() {
      return {
        tag: "u"
      };
    },
    strong: function strong() {
      return {
        tag: "strong"
      };
    },
    code: function code() {
      return {
        tag: "code"
      };
    },
    italic: function italic() {
      return {
        tag: "i"
      };
    },
    link: function link(t) {
      var r = _objectSpread({}, t.attrs),
          _t$attrs$linktype = t.attrs.linktype,
          e = _t$attrs$linktype === void 0 ? "url" : _t$attrs$linktype;

      return "email" === e && (r.href = "mailto:" + r.href), r.anchor && (r.href = "".concat(r.href, "#").concat(r.anchor), delete r.anchor), {
        tag: [{
          tag: "a",
          attrs: r
        }]
      };
    },
    styled: function styled(t) {
      return {
        tag: [{
          tag: "span",
          attrs: t.attrs
        }]
      };
    }
  }
};

var _default = /*#__PURE__*/function () {
  function _default(t) {
    _classCallCheck(this, _default);

    t || (t = r), this.marks = t.marks || [], this.nodes = t.nodes || [];
  }

  _createClass(_default, [{
    key: "addNode",
    value: function addNode(t, r) {
      this.nodes[t] = r;
    }
  }, {
    key: "addMark",
    value: function addMark(t, r) {
      this.marks[t] = r;
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (t.content && Array.isArray(t.content)) {
        var _r = "";
        return t.content.forEach(function (t) {
          _r += _this.renderNode(t);
        }), _r;
      }

      return console.warn("The render method must receive an object with a content field, which is an array"), "";
    }
  }, {
    key: "renderNode",
    value: function renderNode(t) {
      var _this2 = this;

      var r = [];
      t.marks && t.marks.forEach(function (t) {
        var e = _this2.getMatchingMark(t);

        e && r.push(_this2.renderOpeningTag(e.tag));
      });
      var e = this.getMatchingNode(t);
      return e && e.tag && r.push(this.renderOpeningTag(e.tag)), t.content ? t.content.forEach(function (t) {
        r.push(_this2.renderNode(t));
      }) : t.text ? r.push(function (t) {
        var r = {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;"
        },
            e = /[&<>"']/g,
            n = RegExp(e.source);
        return t && n.test(t) ? t.replace(e, function (t) {
          return r[t];
        }) : t;
      }(t.text)) : e && e.singleTag ? r.push(this.renderTag(e.singleTag, " /")) : e && e.html && r.push(e.html), e && e.tag && r.push(this.renderClosingTag(e.tag)), t.marks && t.marks.slice(0).reverse().forEach(function (t) {
        var e = _this2.getMatchingMark(t);

        e && r.push(_this2.renderClosingTag(e.tag));
      }), r.join("");
    }
  }, {
    key: "renderTag",
    value: function renderTag(t, r) {
      if (t.constructor === String) return "<".concat(t).concat(r, ">");
      return t.map(function (t) {
        if (t.constructor === String) return "<".concat(t).concat(r, ">");
        {
          var e = "<" + t.tag;
          if (t.attrs) for (var _r2 in t.attrs) {
            var n = t.attrs[_r2];
            null !== n && (e += " ".concat(_r2, "=\"").concat(n, "\""));
          }
          return "".concat(e).concat(r, ">");
        }
      }).join("");
    }
  }, {
    key: "renderOpeningTag",
    value: function renderOpeningTag(t) {
      return this.renderTag(t, "");
    }
  }, {
    key: "renderClosingTag",
    value: function renderClosingTag(t) {
      if (t.constructor === String) return "</".concat(t, ">");
      return t.slice(0).reverse().map(function (t) {
        return t.constructor === String ? "</".concat(t, ">") : "</".concat(t.tag, ">");
      }).join("");
    }
  }, {
    key: "getMatchingNode",
    value: function getMatchingNode(t) {
      if ("function" == typeof this.nodes[t.type]) return this.nodes[t.type](t);
    }
  }, {
    key: "getMatchingMark",
    value: function getMatchingMark(t) {
      if ("function" == typeof this.marks[t.type]) return this.marks[t.type](t);
    }
  }]);

  return _default;
}();

export { _default as default };